import React from 'react'
import Link from 'gatsby-link'

const SecondPage = () => (
  <div>
    <div className='Instruction'>
      <div className='InstructionGroup'>
        <h1>Step 1: Learn about gender bias in autocomplete</h1>
<progress value="20" max="100">20 %</progress>
        <p>* Gender bias refers to a person receiving different treatment based on the person's real or perceived gender identity. Gender bias can lead to higher levels of stress, anxiety, depression, and post-traumatic stress disorder in women.
                <br></br><br></br>* In this step, you will learn about gender bias in autocomplete. First of all, autocomplete, or word completion, is a feature in which an AI system predicts words following what a user has typed. For example, if one types "Today," AI might predict "is a good day," since this is a frequent pattern in people's expressions.
                <br></br><br></br> * In the book "Algorithms of Oppression," the author noted that the autocomplete system in Google search often predicts stereotypical words when people search "women" or "black people."
	<br></br><br></br>* We want an algorithm to conduct unbiased word completion. However, drawing on past data would simply reinforce the biases contained. For example, biased expressions often occur in people's search queries, and are learned by the autocomplete model.
	<br></br><br></br>* We would like our algorithm to correct for gender bias. We can do it in two ways: (1) removing bias in training data; (2) removing bias in generated expressions.
        </p>
        <p>So good so far? 
        </p>
        <Link to="/0-introduction/">Back</Link>
        <Link to="/2-acquire/">Next step</Link>	
        <Link to="/">Go back to the homepage</Link>
      </div>
    </div>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/1-bias.js